export const copyToClipboard = (str: string) => {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(str).catch(() => {
      copyWithTextarea(str)
    })
    return
  }
  copyWithTextarea(str)
}

const copyWithTextarea = (str: string) => {
  const el = document.createElement("textarea")
  el.value = str
  el.setAttribute("readonly", "")
  el.style.position = "fixed"
  el.style.top = "0"
  el.style.left = "0"
  el.style.opacity = "0"
  document.body.appendChild(el)
  el.focus()
  el.select()
  el.setSelectionRange(0, el.value.length)
  try {
    document.execCommand("copy")
  } finally {
    document.body.removeChild(el)
  }
}

export const getPadLink = (padName: string) => {
  return `${window.location.origin}/${padName}`
}

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) {
    return `${bytes} B`
  }
  const kb = bytes / 1024
  if (kb < 1024) {
    return `${kb < 10 ? kb.toFixed(1) : Math.round(kb)} KB`
  }
  const mb = kb / 1024
  return `${mb < 10 ? mb.toFixed(1) : Math.round(mb)} MB`
}

